import { ModalWrapper } from "../../../components/ModalWrapper";
import { SignalReportSubmissionCard } from "../../../components";
import WatchlistDataReview from "./WatchlistDataReview";

export const WatchlistReviewModal = ({ contentData, onClose }) => {
  const isOpen = !!contentData;

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <ModalWrapper
      title="SignalCheck hit(s) report"
      isOpen={isOpen}
      onClose={handleCloseModal}
    >
      <SignalReportSubmissionCard data={contentData} />
      <WatchlistDataReview data={contentData} />
    </ModalWrapper>
  );
};
